import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core';
import Radio from '@mui/material/Radio';
import { useHMapContext } from '../hooks/useHMapContext';
import { getVisibleHeatmaps } from '../utils/heatmapSelection';

// current Tab ?????
const getActiveMaps = (allHeatMaps, sortSearch) => {
  /**
    if allHeatMaps does not exists | if allHeatMaps is not an array
    return an empty array []
   */
  if (!Array.isArray(allHeatMaps)) return [];

  // if allHeatMaps exists and its an array
  let data = [];
  const { sortOrder, sortType, searchText } = sortSearch['active'];

  // active list heatmaps
  data = getVisibleHeatmaps(allHeatMaps).filter((item) => item.pin);

  // apply search criteria
  if (searchText) {
    data = data.filter((item) =>
      item.name.toLowerCase().includes(searchText.toLowerCase())
    );
  }

  // apply sorting criteria
  if (sortOrder && sortType) {
    data.sort((a, b) => {
      if (sortType === 'az' && sortOrder === 'asc') {
        return a.name.localeCompare(b.name);
      }

      if (sortType === 'az' && sortOrder === 'desc') {
        return b.name.localeCompare(a.name);
      }

      if (sortType === 'date' && sortOrder === 'asc') {
        return Date.parse(a.created_at) - Date.parse(b.created_at);
      }

      if (sortType === 'date' && sortOrder === 'desc') {
        return Date.parse(b.created_at) - Date.parse(a.created_at);
      }

      return a.name.localeCompare(b.name);
    });
  }

  return data;
};

const HMapActiveList = () => {
  const {
    allHeatMapsList,
    currentMapInfo,
    allGeoZoneList,
    geoZoneStateInfo,
    sortSearchInfo
  } = useHMapContext();
  const [currentMap, , handleCurrentMapChange] = currentMapInfo;
  const [geoZoneState] = geoZoneStateInfo;
  const [allGeoZones] = allGeoZoneList;
  const geoZoneEmpty = useMemo(
    () => allGeoZones !== 'loading' && allGeoZones && !!allGeoZones.length,
    [allGeoZones]
  );
  const [sortSearch] = sortSearchInfo;
  const [allHeatMaps] = allHeatMapsList;
  // const activeMaps = allHeatMaps.filter((item) => item.pin)
  // get all active maps
  const activeMaps = useMemo(
    () => [...getActiveMaps(allHeatMaps, sortSearch)],
    [allHeatMaps, sortSearch]
  );
  const classes = useStyles({ geoZoneEmpty, geoZoneState });

  return (
    <div className={classes.root}>
      {activeMaps.map((item, idx) => (
        <div key={`bottomMapList_${idx}`} className={classes.mapListItemRow}>
          <Radio
            id={`${item.id}`}
            name={`${item.name}`}
            pin={`${item.pin}`}
            star={`${item.star}`}
            value={`${item.id}`}
            className={classes.radioButton}
            checked={currentMap === item.id}
            onChange={handleCurrentMapChange}
          />
          <div className={classes.mapListItem}>{item.name}</div>
        </div>
      ))}
    </div>
  );
};

export default React.memo(HMapActiveList);

const useStyles = makeStyles((theme, props) => ({
  root: {
    width: '150px',
    backgroundColor: 'white',
    position: 'absolute',
    zIndex: 10,
    right: (props) => (props.geoZoneState && props.geoZoneEmpty ? 290 : 115),
    bottom: 16,
    borderRadius: '5px',
    boxShadow: `1px 2px 5px 0px rgba(0, 0, 0, 0.25)`
  },
  mapListItemRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderBottom: `1px solid transparent`
  },
  mapListItem: {
    width: '100%',
    // padding: '5px',
    ...theme.typography.h6,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  radioButton: {
    '& .MuiSvgIcon-root': {
      fontSize: 15
    },
    color: 'red',
    '&.Mui-checked': {
      color: theme.palette.primary.accent
    }
  }
}));
